import { Typography, Box, Skeleton } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { useTenant } from "hooks/settings";
import { useListSessionsQuery } from "src/store/api/generatedApi";
import { RecentSearchesRow } from "./RecentSearchesRow";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import { OverviewCard } from "./OverviewCard";

export const RecentSearches = () => {
  const { t } = useTenantTranslation();
  const tenant = useTenant();
  const { data: sessions, isLoading } = useListSessionsQuery(
    {
      tenantName: tenant,
    },
    { refetchOnMountOrArgChange: true }
  );

  return (
    <OverviewCard
      title={t("recentSearches")}
      icon={ContentPasteSearchIcon}
      buttonText={t("viewAllSearches")}
      buttonHref={`/${tenant}/optimiser`}
      delay={0}
    >
      {isLoading ? <Skeleton height="100%" variant="rectangular" /> : null}
      {sessions?.slice(0, 3).map((search) => (
        <RecentSearchesRow key={search.session_id} search={search} />
      ))}
      {sessions?.length === 0 ? (
        <Box sx={{ px: 2 }}>
          <Typography variant="body1" sx={{ color: "text.secondary" }}>
            {t("noRecentSearches")}
          </Typography>
        </Box>
      ) : null}
    </OverviewCard>
  );
};
